export const onInitService = ({ getConfig, setContext }) => {
  const proxyBaseUrl = process.env.REACT_APP_PROXY_BASE_URL || "/api";
  const headerAuthKey =
    process.env.REACT_APP_ACCESS_TOKEN_HEADER_KEY || "Authorization";

  setContext(
    "one.axios.proxy.baseUrl",
    getConfig("one.axios.proxy.baseUrl", proxyBaseUrl)
  );

  setContext(
    "one.axios.proxy.registry.key",
    getConfig("one.axios.proxy.registry.key", "registryApi")
  );

  setContext(
    "one.rest.header.accessToken.key",
    getConfig("one.rest.header.accessToken.key", headerAuthKey)
  );
};
